// extracted by mini-css-extract-plugin
export default {"link":"QsJrvF","root":"IMqhY0","label":"oW6ozO"};